





































































































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import CheckboxBlankOutlineIcon from 'vue-material-design-icons/CheckboxBlankOutline.vue';
import CheckboxMarkedOutlineIcon from 'vue-material-design-icons/CheckboxMarkedOutline.vue';
import Content from '@/dex-shared/components/content/Content.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Pagination from '@/components/Pagination.vue';
import Header from '@/components/Header.vue';
import Loading from '@/dex-shared/components/Loading.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
    Content,
    ArrowRightIcon,
    Pagination,
    Header,
    Loading,
    CheckboxBlankOutlineIcon,
    CheckboxMarkedOutlineIcon,
  },

  data() {
    return {
      loaded: true,
      currentPage: 0,
      showDone: false,
      showQuestionReports: false,
      showSolutionReports: false,
      responsibleUser: null,
    };
  },

  computed: {
    ...mapState({
      userId: (state: any) => state.auth.user.id,
    }),
    ...mapGetters({
      reports: 'filterReports',
      questionReports: 'filterQuestionReports',
      solutionReports: 'filterSolutionReports',
    }),
  },

  async mounted() {
    let page = parseInt(this.$route.params.page);
    if (page > 0) {
      this.currentPage = page - 1;
    } else {
      this.$router.replace(`/reports`);
    }
    this.loaded = false;
    await this.$store.dispatch('PULL_REPORTS', {
      currentPage: this.currentPage,
    });
    this.loaded = true;
  },

  methods: {
    changePage: async function(event: any) {
      this.currentPage = event;
      this.loaded = false;
      if (this.showQuestionReports) {
        await this.$store.dispatch('PULL_QUESTION_REPORTS', {
          currentPage: this.currentPage,
        });
      } else {
        await this.$store.dispatch('PULL_REPORTS', {
          currentPage: this.currentPage,
          showDone: this.showDone,
        });
      }
      this.loaded = true;
      this.$router.push(`/reports/${this.currentPage + 1}`);
    },

    openQuestion: function(report: any) {
      let questionId;
      if (report.questionByQuestionId) {
        questionId = report.questionByQuestionId.id;
      } else {
        questionId = report.solutionBySolutionId.questionId;
      }
      let route = this.$router.resolve({
        path: `/questao/${questionId}`,
      });
      window.open(route.href, '_blank');
    },

    toggleReportDone: async function(report: any) {
      let reportId = report.id;
      let newState = !report.done;
      await this.$store.dispatch('TOGGLE_REPORT_DONE', { reportId, newState });
      report.done = !report.done;
    },

    toggleShowDone: async function() {
      //TODO call pull reports with showDone as parameter
      this.showDone = !this.showDone;
      this.loaded = false;
      await this.$store.dispatch('PULL_REPORTS', {
        currentPage: this.currentPage,
        showDone: this.showDone,
      });
      this.loaded = true;
    },

    toggleQuestionReports: async function() {
      this.showQuestionReports = !this.showQuestionReports;
      if (this.showQuestionReports) {
        this.showSolutionReports = false;
      }
      this.loaded = false;
      if (this.showQuestionReports) {
        await this.$store.dispatch('PULL_QUESTION_REPORTS', {
          currentPage: this.currentPage,
        });
      }
      this.loaded = true;
    },

    toggleSolutionReports: async function() {
      this.showSolutionReports = !this.showSolutionReports;
      if (this.showSolutionReports) {
        this.showQuestionReports = false;
      }
      this.loaded = false;
      if (this.showSolutionReports) {
        await this.$store.dispatch('PULL_SOLUTION_REPORTS', {
          currentPage: this.currentPage,
        });
      }
      this.loaded = true;
    },
  },
});
